import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="todesfallschutz"
export default class extends Controller {
	static targets = ["optionen"]

	connect() {}

	updateOptionen({ currentTarget }) {
		if (!this.hasOptionenTarget) return

		switch (currentTarget.value) {
			case "versicherungssumme":
				this.optionenTarget.classList.remove("hidden")
				break
			default:
				this.optionenTarget.classList.add("hidden")
				break
		}
	}
}
